export default "__VITE_ASSET__34n1eT84__"